<div class="bounty-merchant-card" *transloco="let t">
  <div class="card-header">
    <div class="merchant-info">
      <div class="merchant-logo">
        @if (bounty().merchant.logoUrl) {
          <img ngSrc="bounty().merchant.logoUrl" [alt]="bounty().merchant.name" width="44px" height="44px">
        } @else {
          <span class="logo-fallback">{{ getFirstLetter() }}</span>
        }
      </div>
      <span class="merchant-name">{{ bounty().merchant.name }}</span>
    </div>
    <div class="monthly-spend-pill">{{ getMonthlySpendFormatted() }}</div>
  </div>

  <div class="card-content">
    <p class="bounty-description">
      {{
        t('bounty.earnDescription', {
          amount: bounty().amount | loyaltyCurrency,
          merchantName: bounty().merchant.name
        })
      }}
    </p>

    @if (hasProgress()) {
      <div class="progress-steps">
        <div class="step" [class.completed]="isStepCompleted(1)">
          @if (isStepCompleted(1)) {
            <div class="step-icon completed">
              <mat-icon svgIcon="check"></mat-icon>
            </div>
          } @else {
            <span class="step-number">1</span>
          }
          <span class="step-text">{{ t('bounty.steps.merchantSignedUp', {merchantName: bounty().merchant.name}) }}</span>
        </div>

        <div class="step" [class.completed]="isStepCompleted(2)">
          @if (isStepCompleted(2)) {
            <div class="step-icon completed">
              <mat-icon svgIcon="check"></mat-icon>
            </div>
          } @else {
            <span class="step-number">2</span>
          }
          <span class="step-text">{{ t('bounty.steps.campaignLaunched', {merchantName: bounty().merchant.name}) }}</span>
        </div>

        <div class="step" [class.completed]="isStepCompleted(3)">
          @if (isStepCompleted(3)) {
            <div class="step-icon completed">
              <mat-icon svgIcon="check"></mat-icon>
            </div>
          } @else {
            <span class="step-number">3</span>
          }
          <span class="step-text">
            {{ t('bounty.steps.unlockBountyPrefix') }}
            <span class="amount-bold">{{ bounty().amount | loyaltyCurrency }}</span>
            {{ t('bounty.steps.unlockBountySuffix') }}
          </span>
        </div>
      </div>
    } @else {
      <div class="invite-section">
        <span class="invite-text">{{ t('bounty.inviteAndUnlock') }}</span>
        <span class="amount-badge">{{ bounty().amount | loyaltyCurrency }}</span>
        <span class="cash-reward-text">{{ t('bounty.cashReward') }}</span>
      </div>
    }
  </div>

  <button mat-flat-button class="loyalty request-rewards-button" (click)="onRequestRewards()">
    {{ t('bounty.requestRewards') }}
  </button>
</div>
